// @ts-ignore
import { Influxdb } from "./influxdb-lib";
import config from "../../../config";
import { getCurrentCustomerId, getCurrentSiteId } from "../route/routes";
import { AppDispatch, AppGetState } from "../../../store";
import { getSiteLevelToken } from "../../accessTokenManagerActions";

const influxdb = new Influxdb(
  `https://influxdb.traceair.net/${config.env}/write`,
  true,
);
let sendMetricTimer = 0;
let eventListenerAdded = false;

export interface IUploadMetrics {
  [key: string]: number | string | undefined;
}

export const pushMetric = (
  name: string,
  value: IUploadMetrics,
  tags: IUploadMetrics = {},
) => (dispatch: AppDispatch, getState: AppGetState): void => {
  const state = getState();
  const routerState = state.route;
  const userState = state.user;
  const userEmail = userState.email;
  const customerId = getCurrentCustomerId(routerState);
  const siteId = getCurrentSiteId(routerState);

  async function sendMetrics(event?: Event) {
    if (event) {
      event.preventDefault();
      event.returnValue = false;
    }
    if (!siteId) {
      throw new Error(
        "Unexpected runtime error: site id is not defined, can't send metrics",
      );
    }
    const accessToken = await dispatch(getSiteLevelToken(customerId, siteId));
    influxdb.send(accessToken);
    sendMetricTimer = 0;
    window.removeEventListener("beforeunload", sendMetrics);
    eventListenerAdded = false;
    return false;
  }

  influxdb.point(
    name,
    { ...value },
    {
      Customer: customerId,
      Site: siteId,
      UserEmail: userEmail,
      Environment: config.env,
      ...tags,
    },
    Date.now() * 1000000,
  );
  if (!eventListenerAdded) {
    window.addEventListener("beforeunload", sendMetrics);
    eventListenerAdded = true;
  }
  if (!sendMetricTimer) {
    sendMetricTimer = window.setTimeout(() => {
      sendMetrics();
    }, 15 * 1000);
  }
};
